import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-radio-group"
    }}>{`sp-radio-group`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a group of radio buttons horizontally or vertically (column layout), with an optional field label.`}</p>
    <p><img alt="Radio groups" src={require("../../assets/sp-radio.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/radio-button/"
        }}>{`https://spectrum.adobe.com/page/radio-button/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/radio"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/radio`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio-group>
    <sp-label slot="label">Select a product:</sp-label>
    <sp-radio value="ps">Adobe Photoshop</sp-radio>
    <sp-radio value="xd">Adobe XD</sp-radio>
</sp-radio-group>
`}</code></pre>
    <h2 {...{
      "id": "layout"
    }}>{`Layout`}</h2>
    <p>{`By default, radio groups are laid out horizontally. If you add the `}<inlineCode parentName="p">{`column`}</inlineCode>{` attribute, the radio group will be laid out vertically.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio-group column>
    <sp-radio value="ps">Adobe Photoshop</sp-radio>
    <sp-radio value="xd">Adobe XD</sp-radio>
</sp-radio-group>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes in the radio group using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourRadioGroup").addEventListener("change", evt => {
    console.log(\`Selected item: \${evt.target.value}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      